import { useEffect, useState } from 'react'

// If we ever want to re-use this hook, we should probably delegate the subscription
// onto a singleton to avoid listener spam
export const useIsFileDraggingAnywhereInViewport = () => {
  const [isDragging, setIsDragging] = useState(false)

  const dragoverHandler = (e: DragEvent) => {
    setIsDragging(isEvtWithFiles(e))
  }

  const dragLeaveHandler = (e: DragEvent) => {
    // https://stackoverflow.com/questions/69711768/how-to-avoid-a-child-div-in-react-invoking-a-parents-ondragleave-event?rq=1
    if ((e.currentTarget as any)?.contains(e.relatedTarget)) {
      return
    }

    setIsDragging(false)
  }

  useEffect(() => {
    document.body.addEventListener('dragover', dragoverHandler)
    document.body.addEventListener('dragleave', dragLeaveHandler)
    document.body.addEventListener('drop', dragLeaveHandler)
    return () => {
      document.body.removeEventListener('dragover', dragoverHandler)
      document.body.removeEventListener('dragleave', dragLeaveHandler)
      document.body.removeEventListener('drop', dragLeaveHandler)
    }
  }, [])

  return isDragging
}

// Taken from react-dropzone: https://github.com/react-dropzone/react-dropzone/blob/c17831433243e28e6ada34cccbc14865877be1e0/src/utils/index.js#L113
export function isEvtWithFiles(event: any) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
  return Array.prototype.some.call(
    event.dataTransfer.types,
    type => type === 'Files' || type === 'application/x-moz-file'
  )
}
